export default {
    namespaced: true,
    bookmarkCategory: {
        title: 'Bookmark Category',
        name: 'Name',
        description: 'Description',
        color: 'Color',
        dispatchAlarm: 'Dispatch alarm'
    }
}
